import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  class: "jelly-container",
  ref: "containerRef"
}
const _hoisted_2 = {
  class: "jelly-svg",
  width: "100%",
  height: "100%",
  viewBox: "0 0 200 70",
  preserveAspectRatio: "none"
}
const _hoisted_3 = {
  id: "jellygradient",
  x1: "0%",
  y1: "0%",
  x2: "0%",
  y2: "100%"
}
const _hoisted_4 = ["stop-color"]
const _hoisted_5 = ["stop-color"]
const _hoisted_6 = ["stop-color"]
const _hoisted_7 = {
  ref: "pathRef",
  d: "M0,0 L200,0 L200,70 L0,70 Z",
  fill: "url(#jellygradient)",
  filter: "url(#gooey-filter)"
}
const _hoisted_8 = { class: "jelly-content" }
const _hoisted_9 = { class: "jelly-btn-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "jelly-button",
      ref: "buttonRef",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleClick && _ctx.handleClick(...args))),
      style: _normalizeStyle(_ctx.buttonStyle)
    }, [
      (_openBlock(), _createElementBlock("svg", _hoisted_2, [
        _createElementVNode("defs", null, [
          _cache[1] || (_cache[1] = _createElementVNode("filter", { id: "gooey-filter" }, [
            _createElementVNode("feGaussianBlur", {
              in: "SourceGraphic",
              stdDeviation: "8",
              result: "blur"
            }),
            _createElementVNode("feColorMatrix", {
              in: "blur",
              mode: "matrix",
              values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 19 -9",
              result: "gooey"
            }),
            _createElementVNode("feComposite", {
              in: "SourceGraphic",
              in2: "gooey",
              operator: "atop"
            })
          ], -1)),
          _createElementVNode("linearGradient", _hoisted_3, [
            _createElementVNode("stop", {
              offset: "0%",
              "stop-color": _ctx.colorLight
            }, null, 8, _hoisted_4),
            _createElementVNode("stop", {
              offset: "50%",
              "stop-color": _ctx.buttonColor
            }, null, 8, _hoisted_5),
            _createElementVNode("stop", {
              offset: "100%",
              "stop-color": _ctx.colorDark
            }, null, 8, _hoisted_6)
          ])
        ]),
        _createElementVNode("path", _hoisted_7, null, 512)
      ])),
      _createElementVNode("div", _hoisted_8, [
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "jelly-reflection" }, null, -1)),
        _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.buttonText), 1)
      ])
    ], 4)
  ], 512))
}